/**
 * Canonical part-number form for matching.
 * Inventory stores partNumber UPPERCASE; keep the same here so procurement /
 * planning availability matches stock (e.g. "cm 103" → "CM 103").
 */
export function normalizePartNumber(partNumber) {
  return String(partNumber || '')
    .replace(/\s*\[(?:not\s*mapped)\]\s*$/gi, '')
    .trim()
    .toUpperCase();
}
